import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"id":"axis-select","item-text":"nome","item-name":"eixoId","items":_vm.axis,"label":"Eixo","placeholder":"Eixo","return-object":true},model:{value:(_vm.filter.eixo),callback:function ($$v) {_vm.$set(_vm.filter, "eixo", $$v)},expression:"filter.eixo"}},[_c('template',{slot:"no-data"},[_vm._v("\n    Nenhum Eixo retornado\n  ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }